import { render, staticRenderFns } from "./CustomerQuotesAdd.vue?vue&type=template&id=bb1010a4&"
import script from "./CustomerQuotesAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerQuotesAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQuotesAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports